

































































































import { Vue, Component, Prop, Mixins, Watch } from "vue-property-decorator";
import CustomContainer from "@/components/Globals/CustomContainer.vue";
import CustomText from "@/components/Globals/CustomText.vue";
import CustomImage from "@/components/Globals/CustomImage.vue";
import CustomButton from "@/components/Globals/CustomButton.vue";
import CustomTooltip from '@/components/Globals/CustomTooltip.vue';
import { IAddYourImageGalleryItems, IGalleryItemsImgList } from "./Globals/types/ugc.t";
import { external3DScene } from '@/mixins/external3DScene';

const TWEEN = require('@tweenjs/tween.js');

@Component({
  components: {
    CustomContainer,
    CustomImage,
    CustomText,
    CustomButton,
    CustomTooltip
  },
})
export default class ImageGallery extends Mixins(external3DScene) {
  [x: string]: any;

  @Prop({ default: [] })
  gallery?: IAddYourImageGalleryItems[];

  @Prop()
  selectedImageId!: String | Number;

  public selectedImage?: IGalleryItemsImgList;

  public renderSvgImage: boolean = true;

  public image: any = null;

  isLoadingImage: boolean = true;

  get pdm() {
    return this.$store.state.utils.pdm;
  }
  get queryParams() {
    return this.$store.state.utils.queryParams;
  }

  get externalSelectedStyole() {
    return this.$store.state.UGCEntryPoint?.selectedModel
  }

  get translations() {
    return (
      this.$store.state.translations?.data?.modals?.addYourImageGallery || {}
    );
  }

  get selectedStyle() {
    return this.$store.state.UGCEntryPoint?.selectedStyle
  }

  get stylesComponent() {
    return this.$store.state.UGCEntryPoint?.selectableStyles[this.selectedStyle]
  }

  get isApparel() {
    return this.$store.getters['utils/isApparelEnabled'];
  }

  get activeUGCComponentName() {
    return this.$store.state.ugc?.tempData?.features[1]?.activeUGCComponent;
  }

  get selectedImages() {
    return this.$store.state.imageGallery.selectedImages;
  }

  get isSecondComponentFlow() {
    return this.$store.getters["imageGallery/isSecondComponentFlow"];
  }

  @Watch('gallery')
  public watchGallery() {
    this.checkEnableGallery();
    this.expandInitialImageCategory();
  }

  checkEnableGallery() {
    this.gallery?.forEach((item:IAddYourImageGalleryItems, index: number) => {
      document.getElementById(`scroll-frame${index}`)?.addEventListener("touchmove", () => {
        this.scrollGalleryTouch(item, index);
      }, false);
      document.addEventListener('touchstart', e => {
        item.touchStartX = e.changedTouches[0].screenX;
      });
      document.addEventListener('touchend', e => {
        item.touchEndX = e.changedTouches[0].screenX;
      });
    });
  }

  init3Dscene() {
    this.initExternal3Dscene({domEl: "library-3d-scene", sizeDivider: this.isApparel ? 1.6 : 1.8});
  }

  showRotateMsgTooltip() {
    this.showRotateMsg = true;
    setTimeout(() => {
      this.showRotateMsg = false;
    }, 3000);
  }

  scrollToTop(index: number, expanded: boolean): void {
    if (!expanded) return;
    const scrollContainer = document.getElementsByClassName('image-gallery-container')[0] as HTMLElement;
    const scrollEL = document.getElementById(`gallery-${index}`);
    scrollContainer.scrollTo({top: (scrollEL!.offsetTop - scrollContainer.offsetTop), behavior: "smooth"});
  }

  toggleExpand(index: number) {
    if(!this.gallery) return;
    const item = {...this.gallery[index]};
    item.isExpanded = !item.isExpanded;

    this.gallery.forEach((item, i)=> {
      if(i !== index) {
        item.isExpanded = false;
      }
    });
    this.gallery[index].isExpanded = item.isExpanded;
    this.$nextTick(() => {
      this.scrollToTop(index, item.isExpanded);
    })
    this.$ugcDataLayer.logAnalyticsEvent({
      action: 'imageLibrary',
      type: this.$ugcDataLayer.types.toggleCategory,
      eventLabel: item.isExpanded ? 'All' : 'Less',
      category: item.key
    });
  }

  animate(time: number) {
	  requestAnimationFrame(this.animate);
	  TWEEN.default.update(time);
  }

  scrollGalleryRight(index: number): void {
    requestAnimationFrame(this.animate);
    const scrollContainer = document.querySelector(`#image-gallery-carrousel-${index} `);
    const coords = { x: scrollContainer?.scrollLeft || 0, y: 0 };
    const tween = new TWEEN.default.Tween(coords);
    const currentX = ((scrollContainer?.scrollLeft || 0) + 200);
    tween.to({ x: currentX, y: 0 }, 1000)
    .easing(TWEEN.default.Easing.Cubic.Out)
    .onUpdate(function() {
        if(currentX >= coords.x) {
          scrollContainer ? scrollContainer.scrollLeft = coords.x : "";
        }
    })
    .start();
  }

  scrollGalleryLeft(index: number): void {
    requestAnimationFrame(this.animate);
    const scrollContainer = document.querySelector(`#image-gallery-carrousel-${index} `);
    const coords = { x: scrollContainer?.scrollLeft || 0, y: 0 };
    const tween = new TWEEN.default.Tween(coords);
    const currentX = ((scrollContainer?.scrollLeft || 0) - 200);
    tween.to({ x: currentX, y: 0 }, 1000)
    .easing(TWEEN.default.Easing.Cubic.Out)
    .onUpdate(function() {
        if(currentX <= coords.x) {
          scrollContainer ? scrollContainer.scrollLeft = coords.x : "";
        }
    })
    .start();
  }

  scrollGalleryTouch(item: IAddYourImageGalleryItems, index: number): void {
    if(item.touchEndX && item.touchStartX){
      if (item?.touchEndX < item?.touchStartX) {
      this.scrollGalleryRight(index);
    }
    if (item.touchEndX > item.touchStartX) {
        this.scrollGalleryLeft(index);
      }
    }
  }

  // to be defined
  colorMappingModelComponent(model: any) {

  }
  // to be defined
  setLoadedImage() {

  }
  // to be defined
  svgSelected() {

  }
  // to be defined
  ctaPrimaryAction() {

  }

  onSelectImage(img: IGalleryItemsImgList, category: string): void {
    if(img?.ugc?.original_image?.image_id === this.selectedImageId || img === this.selectedImage || this.isLoadingImage) return;
    this.isLoadingImage = true;
    this.$emit('isApplyingData', true);

    img.category = category;
    this.selectedImage = img;
    this.applyTexture({imgUrl: img?.ugc?.ugc_swatch?.image_url, componentName: this.activeUGCComponentName})
      .then(() => {
        this.animateExternal3dScene();
        this.$emit('selectImage', this.selectedImage);
        this.$emit('isApplyingData', false);
        this.isLoadingImage = false;
      });
  }

  applyInitialTextures() {
    this.$store.commit("ugc/tempData/HAS_FINISHED_APPLYING", false);
    if (!this.selectedImages || this.selectedImages?.length < 1) {
      this.isLoadingImage = false;
      this.$store.commit("ugc/tempData/HAS_FINISHED_APPLYING", true);
      return;
    }
    const components = Object.keys(this.selectedImages);
    components.forEach((component, index) => {
      this.applyTexture({imgUrl: this.selectedImages[component].ugc_swatch?.image_url, componentName: component})
        .then(() => {
          this.animateExternal3dScene();
          if (components.length === index + 1) {
            this.$store.commit("ugc/tempData/HAS_FINISHED_APPLYING", true);
            this.isLoadingImage = false;
          }
        });
    })
  }

  expandInitialImageCategory() {
    const categorySelected = this.$store.state.imageGallery.image_category;
    const categoryIndex = this.gallery?.map(category => category.key).indexOf(categorySelected);
    if (categoryIndex && categoryIndex >= 0) {
      this.toggleExpand(categoryIndex);
    }
  }

  created() {
    this.$store.commit("ugc/tempData/HAS_FINISHED_APPLYING", false);
  }

  mounted() {
    this.isLoadingImage = true;
    this.init3Dscene();
    this.$nextTick(() => {
      this.applyInitialTextures();
    });
  }

  destroyed() {
    this.disposeScene();
  }
}
